<template>
  <div class="container--lg pt1 pb1">
    <div class="grid-row">
      <p class=" mb1">{{ question.question }}</p>
    </div>

    <template v-if="reviewMode || questionIsAnswered">
      <div v-for="(option, index) in question.options" :key="index">
        <div class="grid-row">
          <label v-bind:class="{ options__selected: selectedOption ==  option.option }">
            <input name="option" type="radio" v-model="selectedOption" v-bind:value="option.option" :disabled="true">
            {{ option.option }}
          </label>
        </div>
        <div class="grid-row">
          <template v-if="rightAnswer(option, selectedOption)">
            <p class="bg--green text--white pl1 pr2">{{ rightAnswer(option, selectedOption) }}</p>
          </template>
          <template v-if="wrongAnswer(option, selectedOption)">
            <p class="bg--red text--white pl1 pr2">{{ wrongAnswer(option, selectedOption) }}</p>
          </template>
        </div>
      </div>

      <div class="grid-row grid-row--center" v-if="tip">
        Tip: {{ tip }}
      </div>
    </template>

    <template v-if="!reviewMode && !questionIsAnswered">
      <div class="grid-row" v-for="(option, index) in question.options" :key="index">
        <label class="options" v-bind:class="{ options__selected: selectedOption ==  option.option }">
          <input name="option" type="radio" v-model="selectedOption" v-bind:value="option.option">
          {{ option.option }}
        </label>
      </div>
    </template>

    <template v-if="reviewMode">
      <div class="grid-row">
        <div class="grid-column mt2 span-half">
          <button v-on:click="nextQuestionReview()" class="btn btn--primary">next</button>
        </div>
        <div class="grid-column mt2 span-half">
          <button class="btn btn--primary"><router-link to="/quiz">new quiz</router-link></button>
        </div>
      </div>
    </template>

    <template v-if="!reviewMode">
      <div class="grid-row">
        <div class="grid-column mt2 span-half">
          <button v-on:click="previousQuestion()" class="btn btn--primary" :disabled="previousButtonDisabled">previous</button>
        </div>
        <div class="grid-column mt2 span-half">
          <button v-on:click="nextQuestion()" class="btn btn--primary" :disabled="nextButtonDisabled">{{ nextButtonText }}</button>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
  export default {
    name: "Question",
    data() {
      return {
        selectedOption: null,
        questionState: "unanswered",
      }
    },

    props: {
      question: {
        type: Object,
        required: true
      },

      reviewMode: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      currentQuestionNumber() {
        return this.$store.state.currentQuestionNumber
      },

      currentQuestionReviewNumber(){
        return this.$store.state.currentQuestionReviewNumber
      },

      correctNumberOfQuestions() {
        return this.$store.state.correctNumberOfQuestions
      },

      correctOption() {
        return this.question.options.find((option) => {
          return option.shouldBeSelected === true
        })
      },

      nextButtonText() {
        if (this.questionState == "unanswered") {
          return "submit"
        } else {
          if (this.currentQuestionNumber == this.actualNumberOfQuestions) { return "finish" }
          return "next"
        }
      },

      nextButtonDisabled() {
        return (this.selectedOption === null)
      },

      previousButtonDisabled() {
        return (this.currentQuestionNumber <= 1)
      },

      questionIsAnswered() {
        return (this.questionState == "answered" )
      },

      actualNumberOfQuestions() {
        return this.$store.state.actualNumberOfQuestions
      },

      tip() {
        return this.question.tip
      }
    },

    methods: {
      previousQuestion() {
        this.$store.commit("setCurrentQuestionNumber", this.currentQuestionNumber - 1)
      },

      nextQuestion() {

        if (this.questionState == "unanswered") {
          this.questionState = "answered"
        } else {
          if (this.selectedOption === this.correctOption.option) {
            var correctNumberOfQuestions = this.$store.state.correctNumberOfQuestions
            this.$store.commit("setCorrectNumberOfQuestions", correctNumberOfQuestions + 1)
          }

          let answeredQuestion = Object.assign({ actualSelected: this.selectedOption }, this.question)
          this.$store.commit("addAnsweredQuestion", answeredQuestion)

          if (this.currentQuestionNumber < this.actualNumberOfQuestions) {
            this.$store.commit("setCurrentQuestionNumber", this.currentQuestionNumber + 1)
          } else {
            this.$router.push({ path: '/result' })
          }
        }
      },

      nextQuestionReview() {
        let wrongNumberOfQuestions = this.actualNumberOfQuestions - this.correctNumberOfQuestions
        var questionReviewNumber

        if (this.currentQuestionReviewNumber == wrongNumberOfQuestions) {
          questionReviewNumber = 1
        } else {
          questionReviewNumber = this.currentQuestionReviewNumber + 1
        }

        this.$store.commit("setCurrentQuestionReviewNumber", questionReviewNumber)
      },

      rightAnswer(option, selectedOption) {
        if (selectedOption == option.option && option.shouldBeSelected) {
          return "the option above is correct! Great job!"
        }
      },

      wrongAnswer(option, selectedOption) {
        if (selectedOption === option.option && !option.shouldBeSelected) {
          return "the option above should not be selected"
        }

        if (selectedOption !== option.option && option.shouldBeSelected) {
          return "the option above should be selected"
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/components/Question.vue